import { render, staticRenderFns } from "./RealVideo.vue?vue&type=template&id=656748ae&scoped=true"
import script from "./RealVideo.vue?vue&type=script&lang=js"
export * from "./RealVideo.vue?vue&type=script&lang=js"
import style0 from "./RealVideo.vue?vue&type=style&index=0&id=656748ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656748ae",
  null
  
)

export default component.exports